<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline title="Teacher Performance"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Teacher Performance
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="14" lg="10" class="my-0 mr-0 py-0">
            <v-card-text  class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
               <v-card-actions>
                 <a @click="$router.back()">
                   <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
                   <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
                   <v-icon>mdi-arrow-left</v-icon>
                   </v-btn>
                 </a>
              </v-card-actions>
            </v-card-text>
          </v-col>
        </v-row>
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" md="6">
            <v-select v-model="formData.state" :items="stateData" item-text="name" item-value="name" label="Select State"></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Enter City" placeholder="Enter your city" v-model="formData.city"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="formData.franchiseeID" :items="franchiseeData" item-text="companyName" item-value="id" label="Select Center"></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn class="mr-4" color="success" elevation="1" @click="searchRecord()">
              <v-icon left> mdi-magnify </v-icon>
              Search</v-btn
            >
            <v-btn elevation="1" @click="resetFilter()">
              <v-icon left> mdi-restart</v-icon>
              Reset
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          ></v-text-field>
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table :headers="headers" :search="search" :items="teacherPerformanceData" :items-per-page="10" class="elevation-1">
          <!-- <template v-slot:item.teacherName="{ item }"> {{ item.userStaff.user.firstName }} {{ item.userStaff.user.lastName || '' }} </template> -->
          <template v-slot:item.completedModules="{ item }"> {{ item.completedModules }}/{{ item.totalModules }} </template>
          <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'teacherPerformanceRecord', params: { staffID: item.staffID } }">
              <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                <v-icon small color="black"> mdi-eye</v-icon>
              </v-btn>
            </router-link>
          </template>
        </v-data-table>
      </v-card>
    <!-- </material-card> -->

    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
// import VCardComponent from '@/components/template/VCardComponent'
import _ from 'lodash'
// import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'OnlineClassList',
  // components: { MaterialCard, VCardComponent },
  data () {
    return {
      data: [],
      stateData: [],
      franchiseeData: [],
      teacherPerformanceData: [],
      search: '',
      formData: {
        state: '',
        franchiseeID: '',
        city: ''
      },
      headers: [
        { text: 'Teacher Name', sortable: true, value: 'fullName' },
        { text: 'Center', sortable: true, value: 'trainingRequest.trainingRequestFranchiseeMaps[0].franchisee.companyName' },
        { text: 'State', sortable: true, value: 'trainingRequest.state' },
        { text: 'City', sortable: true, value: 'trainingRequest.city' },
        { text: 'Training', sortable: true, value: 'trainingRequest.training.name' },
        { text: 'Class Group', sortable: true, value: 'trainingRequest.studentClassGroup.name' },
        { text: 'Completed Modules', sortable: true, value: 'completedModules' },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      itemData: [],
      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      await this.getStateCityDetails()
      await this.getFranchiseeData()
      await this.getTeacherPerformance()
      // this.isWrite = Utils.helper.getIsWriteFun(this.$route)
      // this.isLoading = true
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      this.errMsg(errorMessage)
    }
  },
  methods: {
    resetFilter: async function () {
      this.formData = {
        state: '',
        franchiseeID: '',
        city: ''
      }
      await this.getTeacherPerformance()
    },
    searchRecord: async function () {
      await this.getTeacherPerformance()
    },
    getTeacherPerformance: async function () {
      try {
        let transection
        let filterObj = {}
        if (this.formData) {
          if (this.formData.state) {
            filterObj.state = this.formData.state
          }
          if (this.formData.franchiseeID) {
            filterObj.franchiseeID = this.formData.franchiseeID
          }
          if (this.formData.city) {
            filterObj.city = this.formData.city
          }
        }

        this.isLoading = true
        if (filterObj) {
          transection = http.get(`${constants.API_URL}/api/teacher-training/records/get-all-training`, {
            params: filterObj
          })
        } else {
          transection = http.get(`${constants.API_URL}/api/teacher-training/records/get-all-training`)
        }
        let { data } = await transection
        this.isLoading = false
        _.map(data, d => {
          if (d.trainingRequest.training) {
            d.totalModules = d.trainingRequest.training.trainingModuleMaps.length
          }
          const completedModle = _.filter(d.trainingRecordModules, data => {
            return data.status.toLowerCase() !== 'not started'
          })
          d.completedModules = !_.isEmpty(completedModle) ? completedModle.length : 0
        })
        this.teacherPerformanceData = data
        this.teacherPerformanceData = _.map(this.teacherPerformanceData, a => {
          a.fullName = `${a.userStaff.user.firstName} ${a.userStaff.user.lastName}`
          return a
        })
        // this.franchiseeData = data.rows
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getFranchiseeData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.isLoading = false
        this.franchiseeData = data.rows
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getStateCityDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/states`)
        this.stateData = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
